module.exports = __webpack_public_path__ + "components/layout/images/wechat-img.jpg?c707b569";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/wechat-img.jpg
// module id = 239
// module chunks = 0